(ns frontend.view.settings2.decisions.sub
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::show-archived-investment-reservation-types?
 (fn [db _]
   (get db ::show-archived-investment-reservation-types?)))

(rf/reg-sub
 ::submit-error?
 (fn [db _]
   (get db ::submit-error?)))

(rf/reg-sub
 ::submit-error-dialog
 (fn [db _]
   (get db ::submit-error-dialog)))

